import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
    selector: '[animated]',
    standalone: true,
})
export class AnimatedDirective
{
    @Input() hasAnimation = true;
    @Input() fadeFrom: 'top' | 'bottom' | 'right' | 'left';

    @HostBinding('class.animated') get animatedClass() {
        return this.hasAnimation;
    }
    @HostBinding('class.fadeIn') get fadeInClass() {
        return this.animatedClass && !this.fadeFrom;
    }
    @HostBinding('class.fadeInTop') get fadeInTopClass() {
        return this.animatedClass && this.fadeFrom === 'top';
    }
    @HostBinding('class.fadeInBottom') get fadeInBottomClass() {
        return this.animatedClass && this.fadeFrom === 'bottom';
    }
    @HostBinding('class.fadeInRight') get fadeInRightClass() {
        return this.animatedClass && this.fadeFrom === 'right';
    }
    @HostBinding('class.fadeInLeft') get fadeInLeftClass() {
        return this.animatedClass && this.fadeFrom === 'left';
    }
}

@Directive({
    selector: '[delayed]',
    standalone: true,
})
export class AnimatedDelayDirective
{
    @Input() delayed: 'item' | 'list' | 'table' = 'item';

    @HostBinding('class.animated-delay') get delayedClass() {
        return this.delayed === 'item' || !this.delayed;
    }

    @HostBinding('class.animated-delay-list') get delayedLargeClass() {
        return this.delayed === 'list';
    }

    @HostBinding('class.animated-delay-table') get delayedTableClass() {
        return this.delayed === 'table';
    }
}
